import { mdiLock } from "@mdi/js";
import Icon from "@mdi/react";
import React, { useEffect, useState } from "react";
import { useTranslations } from "../../hooks/useTranslations";

interface props {
    onSubmit: (code: string) => void
    onPrevios: () => void
};

const CodeInput = (props: props)  => {
    const { t } = useTranslations();

    const [code, setCode] = useState<string>('');

    useEffect(()=>{
        if (code.length === 6) {
            props.onSubmit(code);
        }
    }, [code]);


    return (<>
      <div className="card-body text-start">
            <h5 className="card-title">{t('welcome.validationCode')}</h5>

            <div className="input-group mb-3">
                <span className="input-group-text" id="labelCode"><Icon path={mdiLock} size={1} /></span>
                <input type="text"
                    className="form-control"
                    placeholder="_ _ _ _ _ _"
                    aria-label="code"
                    aria-describedby="labelCode"
                    value={code}
                    onChange={(evt) => setCode(evt.target.value)}
                />
            </div>

            <p className="card-text">{t('welcome.entercodefromemail')}</p>
        </div>
        <div className="card-footer text-muted text-start">
            <button className="btn btn-outline-primary" onClick={props.onPrevios}>{t('common.back')}</button>
        </div>
    </>);
}

export { CodeInput };
